module.exports = __webpack_public_path__ + "static/media/groupMemberIcon.daad5d0d.svg";